import React from 'react'
import './pdcabadge.scss'

export default ({ children, variant = 'neutral', className = '' }) => {
  return (
    <span className={`pdca-badge pdca-badge-${variant} ${className}`.trim()}>
      {children}
    </span>
  )
}